module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-mask-2.41811806.png";